import { Box, IconButton, InputBase, InputBaseComponentProps } from "@mui/material";
import { mdiClose, mdiMagnify } from "@mdi/js";
import Icon from "@mdi/react";

export interface SearchInputProps<T> {
  data: T[];
  inputProps?: InputBaseComponentProps;
  searchBy: keyof T;
  searchString: string;
  onSearchedResults: (searchString: string, filteredArray: T[]) => void;
}

function SearchInput<T extends Record<string, unknown>>(props: SearchInputProps<T>) {
  const { data, inputProps, searchBy, searchString, onSearchedResults, ...rest } = props;

  const searchFriend = (value: string) => {
    let filteredArray: T[] = [];

    if (data && data.length) {
      filteredArray = data.filter((friend) =>
        (friend[searchBy] as unknown as string).toLowerCase().includes(value.toLowerCase())
      );
    }

    onSearchedResults(value, filteredArray);
  };

  return (
    <Box alignItems='center' display='flex' py={0.5} px={1}>
      <Box p={1} color='text.secondary' display='flex' alignItems='center'>
        <Icon path={mdiMagnify} size={1} />
      </Box>

      <InputBase
        sx={{ flex: 1 }}
        inputProps={{ "aria-label": "Search", ...inputProps }}
        onChange={(e) => searchFriend(e.target.value)}
        value={searchString}
        {...rest}
      />

      {searchString !== "" && (
        <IconButton type='submit' aria-label='Clear search' onClick={() => searchFriend("")}>
          <Icon path={mdiClose} size={1} />
        </IconButton>
      )}
    </Box>
  );
}

export default SearchInput;
